const DOMPurify = require('dompurify');

// Admin-configured HTML shown instead of the loader while a signed link may redirect.
// The HTML is sanitized on save and when the link is read; sanitizing again here is cheap insurance.
class RedirectScreenCtrl {
  constructor($sce) {
    'ngInject';
    this.$sce = $sce;
    this.content = '';
  }

  $onChanges(changes) {
    if (!changes.html) return;
    const clean = DOMPurify.sanitize(String(this.html || ''), { USE_PROFILES: { html: true } });
    this.content = this.$sce.trustAsHtml(clean);
  }
}

export default {
  bindings: { html: '<' },
  templateUrl: 'form-render/redirect-screen/redirect-screen.component.html',
  controller: RedirectScreenCtrl
};
